import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { useTheme, styled } from '@mui/material/styles';
import { Card, CardHeader } from '@mui/material';
// utils
import { fNumber } from '../../../utils/formatNumber';
import { useChart } from '../../../components/chart';

// ----------------------------------------------------------------------

const StyledChartWrapper = styled('div')(({ theme, chartHeight }) => ({
  height: chartHeight || 150,          // visina grafa
  margin: theme.spacing(1, 0),        // manja margina gore-dole
  '& .apexcharts-canvas svg': { height: chartHeight || 200 },
  '& .apexcharts-canvas svg, .apexcharts-canvas foreignObject': {
    overflow: 'visible',
  },
}));

// ----------------------------------------------------------------------

AppCurrentVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartColors: PropTypes.arrayOf(PropTypes.string),
  chartData: PropTypes.array,
  chartHeight: PropTypes.number,
};

export default function AppCurrentVisits({ title, chartData, chartColors, chartHeight = 100, ...other }) {
  const theme = useTheme();

  const chartLabels = chartData.map((i) => i.label);
  const chartSeries = chartData.map((i) => i.value);

  const chartOptions = useChart({
    colors: chartColors,
    labels: chartLabels,
    legend: { show: false }, // ukloni legendu
    dataLabels: { enabled: false }, // ukloni postotke
    tooltip: { enabled: false }, // opcionalno ukloni tooltip
    plotOptions: {
      pie: {
        donut: { size: '70%' } // smanji donut
      },
    },
  });

  const StyledChartWrapper = styled('div')(({ theme }) => ({
    height: chartHeight,
    '& .apexcharts-canvas svg': { height: chartHeight },
    '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': { overflow: 'visible' },
  }));

  return (
    <Card {...other}>
      <CardHeader title={title} />
      <StyledChartWrapper dir="ltr">
        <ReactApexChart type="pie" series={chartSeries} options={chartOptions} height={chartHeight} />
      </StyledChartWrapper>
    </Card>
  );
}


